import Swiper from 'Swiper';

export default class bannerSlider {
	constructor(element) {
		this.initSlider(element);
	}

	initSlider(element){
		let mySwiper = new Swiper (element, {
			loop: true,
			speed: 1500,
			simulateTouch: false,
			mousewheel: false,
			navigation: {
				nextEl: '.js-next-slide-banner',
				prevEl: '.js-prev-slide-banner',
			},
			effect: 'coverflow',
			coverflowEffect: {
				rotate: 50,
				stretch: -90,
				depth: 100,
				modifier: 1,
				slideShadows: false
			},
			on: {
				slideChangeTransitionStart: function () {
					let prevBtn = element.querySelectorAll('.js-prev-slide-banner');
					let nextBtn = element.querySelectorAll('.js-next-slide-banner');

					prevBtn.forEach((btn) => {
						btn.classList.add('arrows__single--hide-prev');
					});

					nextBtn.forEach((btn) => {
						btn.classList.add('arrows__single--hide-next');
					});


					setTimeout(function(){
						prevBtn.forEach((btn) => {
							btn.classList.remove('arrows__single--hide-prev');
						});

						nextBtn.forEach((btn) => {
							btn.classList.remove('arrows__single--hide-next');
						});
					}, 850);
				}
			}
		})
	}
}